export const initialValues = {
    inviteOnly: [{
        entity: 3,
        specific_documents: [],
        specific_labels: [],
        access_user: [],
        access_role: [],
        entity_name: "",
        project_uuid: "",
    }]
}